export default __webpack_public_path__ + "static/media/M33.bab5fba3.svg";